import { ParametersListAPI } from 'ducks/types/api-types';
import { ProjectParameterItem } from 'ducks/types/store-types';
import { normalizeObjUUID } from 'ducks/utils';

export function normalizeProjectParameters(array: ParametersListAPI[]): ProjectParameterItem[] {
  return array.map((a) =>
    normalizeObjUUID({
      ...a,
      modified: false,
      saved: false,
      delete: false,
      parameter_value_disabled: false,
    }),
  );
}

export function normalizeAndSortProjectParameters(array: ParametersListAPI[]) {
  return normalizeProjectParameters(array).sort((a, b) => (a.parameter_name > b.parameter_name ? 1 : -1));
}
